module.exports = __webpack_public_path__ + "img/BG@3x.8bdb1cd4.png";